import gql from "graphql-tag";

export const rolesAndManagersQuery = gql`
  query rolesAndManagers {
    roles {
      id
      name
      code
      parent {
        code
      }
    }
    managersAvailableForEmployee {
      id
      name
    }
  }
`;
